import moment from "moment/moment";
import React from "react";
import { useNavigate } from "react-router-dom";

const slugify = (text) => {
    return text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w\-]+/g, "")
        .replace(/\-\-+/g, "-")
        .replace(/^-+/, "")
        .replace(/-+$/, "");
};

const CourseDurationAndFees = ({ category, course }) => {
    const navigate = useNavigate();

    const handleViewProgram = (course) => {
        const slug = slugify(course.CourseName);
        navigate(`/${slug}`, { state: { course: course } });
    };

    if (!course || course.length === 0) return null;

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
            <div className="max-w-3xl mb-8">
                <h2 className="text-3xl font-extrabold text-gray-950 mb-3 tracking-tight">
                    {category?.categoryName} Courses Duration & Fees
                </h2>
                <div className="w-12 h-1 bg-blue-600 mb-4 rounded-full"></div>
                <p className="text-lg text-gray-600 font-normal">
                    Comparing courses is easy. Browse durations, fees, and upcoming cohorts below to select the right program for your schedule and budget.
                </p>
            </div>

            <div className="overflow-hidden bg-white border border-gray-100 rounded-2xl shadow-xl shadow-slate-100/50">
                <table className="w-full border-collapse text-left">
                    <thead>
                        <tr className="bg-slate-50 border-b border-gray-100">
                            <th className="p-5 text-xs font-bold uppercase tracking-wider text-gray-800">Course Name & Schedule</th>
                            <th className="p-5 text-xs font-bold uppercase tracking-wider text-gray-800">Duration</th>
                            <th className="p-5 text-xs font-bold uppercase tracking-wider text-gray-800">Enrollment Fees</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {course.map((item, index) => (
                            <tr key={index} className="hover:bg-slate-50/50 transition duration-150 group">
                                <td className="p-5">
                                    <button 
                                        className="text-[16px] font-bold text-gray-900 cursor-pointer hover:text-blue-600 hover:underline transition-colors block text-left mb-1.5"
                                        onClick={() => handleViewProgram(item)}
                                    >
                                        {item?.CourseName}
                                    </button>
                                    <span className="inline-flex items-center gap-1.5 text-xs text-gray-500 font-medium">
                                        <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                                        Cohort Starts: {moment(item?.CreateOn).format("MMM DD, YYYY")}
                                    </span>
                                </td>
                                <td className="p-5">
                                    <span className="inline-flex items-center px-3 py-1 bg-slate-100 border border-slate-200/50 text-slate-800 rounded-full text-xs font-semibold">
                                        {item?.Duration || 0} Hours
                                    </span>
                                </td>
                                <td className="p-5">
                                    <span className="text-base font-extrabold text-blue-600">
                                        ${item?.EnrollmentFee?.toLocaleString() || "0"} USD
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CourseDurationAndFees;